module.exports = __webpack_public_path__ + "img/15.d04f067.png";